<template>
  <fanzone-form
    :id='id'
    redirectTo='/#/fanzones-urban-actions'
    label='Akcje miejskie'
    :idStepsEvent='false'
    :idsRelatedEvents='true'
    :scenesEditor='true'
  />
</template>

<script>
	import fanzoneForm from '../components/FanzoneForm'
	
	export default {
    props: ['id'],
    components: { fanzoneForm },
	}
</script>
